// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YourWardrobeRouteImport } from './routes/your-wardrobe'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StyleMyWardrobeRouteImport } from './routes/style-my-wardrobe'
import { Route as ShopTheLookRouteImport } from './routes/shop-the-look'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PaywallRouteImport } from './routes/paywall'
import { Route as NewJobRouteImport } from './routes/new-job'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as HelpRouteImport } from './routes/help'
import { Route as GetTheLookRouteImport } from './routes/get-the-look'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'

const YourWardrobeRoute = YourWardrobeRouteImport.update({
            id: '/your-wardrobe',path: '/your-wardrobe',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StyleMyWardrobeRoute = StyleMyWardrobeRouteImport.update({
            id: '/style-my-wardrobe',path: '/style-my-wardrobe',getParentRoute: () => rootRouteImport
          })
const ShopTheLookRoute = ShopTheLookRouteImport.update({
            id: '/shop-the-look',path: '/shop-the-look',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PaywallRoute = PaywallRouteImport.update({
            id: '/paywall',path: '/paywall',getParentRoute: () => rootRouteImport
          })
const NewJobRoute = NewJobRouteImport.update({
            id: '/new-job',path: '/new-job',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const GetTheLookRoute = GetTheLookRouteImport.update({
            id: '/get-the-look',path: '/get-the-look',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DeleteAccountRoute = DeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => rootRouteImport
          })
const AccountDeletionRoute = AccountDeletionRouteImport.update({
            id: '/account-deletion',path: '/account-deletion',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountDeletionRoute: AccountDeletionRoute,DeleteAccountRoute: DeleteAccountRoute,FaqRoute: FaqRoute,GetTheLookRoute: GetTheLookRoute,HelpRoute: HelpRoute,HowItWorksRoute: HowItWorksRoute,NewJobRoute: NewJobRoute,PaywallRoute: PaywallRoute,PrivacyRoute: PrivacyRoute,ShopTheLookRoute: ShopTheLookRoute,StyleMyWardrobeRoute: StyleMyWardrobeRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,YourWardrobeRoute: YourWardrobeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)